import React, {FC} from "react";
import {FormControl, InputLabel, Select, MenuItem} from "@material-ui/core";
import {SchemaType} from "common/flowmaster/types/schema";

interface TypeSelectorProps {
  value: SchemaType;
  onChange: (value: SchemaType) => void;
}

const TypeSelector: FC<TypeSelectorProps> = ({value, onChange}) => {
  return (
    <FormControl fullWidth style={{margin: "10px 0px"}}>
      <InputLabel>Type</InputLabel>
      <Select
        value={value}
        onChange={e => onChange(e.target.value as SchemaType)}
        label="Type"
      >
        <MenuItem value="string">String</MenuItem>
        <MenuItem value="number">Number</MenuItem>
        <MenuItem value="object">Object</MenuItem>
        <MenuItem value="array">Array</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TypeSelector;
